import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['label', 'input', 'template'];

  connect() {
    this.element.setAttribute('data-select-controller-connected', 'true');
  }

  select(event) {
    const value = event.currentTarget.dataset.selectValue;
    const displayValue = event.currentTarget.dataset.selectDisplayValue;

    this.inputTarget.value = value;
    this.updateLabel(displayValue, value);

    event.currentTarget.parentNode.querySelectorAll('[aria-selected]').forEach((el) => {
      el.removeAttribute('aria-selected');
    });
    event.currentTarget.setAttribute('aria-selected', true);
    this.dispatch('value-selected', { detail: { value: value } });
  }

  updateLabel(displayValue, value) {
    const template = this.templateTargets.find(
      (template) => template.dataset.selectValue === value,
    );

    if (template) {
      this.updateLabelWithTemplate(template);
    } else {
      this.updateLabelWithText(displayValue || value);
    }
  }

  updateLabelWithTemplate(template) {
    this.labelTarget.innerHTML = '';
    this.labelTarget.appendChild(template.content.cloneNode(true));
  }

  updateLabelWithText(text) {
    this.labelTarget.textContent = capitaliseFirstLetter(text);
  }
}

const capitaliseFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
